<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">Users can view and select a PPC result to validate the line item's prices</div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="user-profile__form">
                <form class="row g-3" [formGroup]="runPPCForm">
                    <div *ngFor="let field of formFields" [ngClass]="field.size">
                        <label [attr.for]="field?.displayName" class="form-label text-small">{{field?.displayName}}
                            <sup style="color :red">*</sup></label>
                        <input [attr.type]="field.fieldSubType" class="form-control form-control-sm"
                            [attr.id]="field?.displayName" [error]="runPPCForm.get(field.fieldName)"
                            [formControlName]="field.fieldName" [attr.placeholder]="field?.displayName">
                        <form-feedback [formGroup]="runPPCForm" [field]="field.fieldName"></form-feedback>
                    </div>
                </form>
            </div>
            <div class="user-profile__action">
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary m-2 text-white" (click)="SearchPPC()"> Search
                    </button>
                </div>
            </div>
            <div class="card mt-1" *ngIf="ppcResults">
                <div class="card-body p-4">
                    <h5>PPC results</h5>
                    <div><span class="text-small">Select a result from below for the line item to be validated</span>
                    </div>
                    <div class="d-flex mb-4 mt-1 justify-content-end">
                        <button type="button" class="btn btn-outline-primary me-2" (click)="validatePrice()">
                            Validate price with selected result
                        </button>
                    </div>
                    <ng-container>
                        <app-ag-grid-wrapper #grid [gridConfig]='gridOptions' [rowData]="ppcResults"
                            [columnDefs]="columnDefs" [frameworkComponents]='frameworkComponents' [context]='context' (gridReady)="onGridReady()">
                        </app-ag-grid-wrapper>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</section>